import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [ 'item' ]

	connect() {
		this.connected = true
		this.sortList()
	}

	itemTargetConnected(element) {
		if (this.connected) { this.sortList() }
	}

	itemTargetDisconnected() {
		if (this.connected) { this.sortList() }
	}

	sortList() {
		if (this.hasItemTarget) {
			const sortedItems = this.itemTargets.sort( (a,b) => {
				const keyA = a.dataset.sortKey.toLowerCase()
				const keyB = b.dataset.sortKey.toLowerCase()
				if (keyA < keyB) { return -1 }
				if (keyA > keyB) { return 1 }
				return 0
			})

			for (const item of sortedItems) {
				this.element.append(item)
			}
		}
	}
}

